export default __webpack_public_path__ + "static/media/Email icon - Light.c4d20b80.svg";